module.exports = __webpack_public_path__ + "static/portfolio-sonnen-b0998e0f7e46712be6e899da2a4a2c30.png";